export default {
  gallery: {
    active: 'Aktive gallerier',
    future: 'Kommende gallerier',
    inactive: 'Arkiverte gallerier',
  },
};
